import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "option", "group", "checkbox", "chipList", "count", "empty"]

  connect() {
    this.update()
    this.filter()
  }

  filter() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""

    this.optionTargets.forEach((option) => {
      const matches = option.dataset.searchText.includes(query)
      option.classList.toggle("hidden", !matches)
    })

    this.groupTargets.forEach((group) => {
      const hasVisibleOption = this.optionTargets.some((option) => {
        return option.dataset.groupKey === group.dataset.groupKey && !option.classList.contains("hidden")
      })
      group.classList.toggle("hidden", !hasVisibleOption)
    })

    this.updateEmptyState()
  }

  toggle() {
    this.update()
  }

  selectVisible() {
    this.optionTargets.forEach((option) => {
      if (!option.classList.contains("hidden")) {
        option.querySelector("input[type='checkbox']").checked = true
      }
    })
    this.update()
  }

  clear() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.update()
  }

  remove(event) {
    const endpointId = event.currentTarget.dataset.endpointId
    const checkbox = this.checkboxTargets.find((target) => target.value === endpointId)
    if (checkbox) checkbox.checked = false
    this.update()
  }

  update() {
    const selected = this.selectedCheckboxes()

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${selected.length} selected`
    }

    if (this.hasChipListTarget) {
      if (selected.length === 0) {
        this.chipListTarget.innerHTML = `<span class="text-sm text-gray-400">No endpoints selected</span>`
      } else {
        this.chipListTarget.innerHTML = selected.map((checkbox) => this.chipFor(checkbox)).join("")
      }
    }

    this.updateEmptyState()
  }

  selectedCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked)
  }

  chipFor(checkbox) {
    const name = this.escapeHtml(checkbox.dataset.endpointName)
    const id = this.escapeHtml(checkbox.value)

    return `
      <span class="inline-flex max-w-full items-center gap-1.5 rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-100">
        <span class="truncate">${name}</span>
        <button type="button"
                class="rounded-full text-indigo-500 hover:text-indigo-800"
                data-action="endpoint-access-picker#remove"
                data-endpoint-id="${id}"
                aria-label="Remove ${name}">
          &times;
        </button>
      </span>
    `
  }

  updateEmptyState() {
    if (!this.hasEmptyTarget) return

    const hasVisibleOption = this.optionTargets.some((option) => !option.classList.contains("hidden"))
    this.emptyTarget.classList.toggle("hidden", hasVisibleOption)
  }

  escapeHtml(value) {
    const element = document.createElement("div")
    element.textContent = value || ""
    return element.innerHTML
  }
}
